import React from 'react';
import { cn } from '@/utils/cn';

function Primary({ children, className = '', disabled = false, ...rest }) {
  return (
    <button
      type="button"
      aria-label="primary button"
      className={cn(
        'px-24 py-10 rounded-[100px] flex justify-center items-center bg-richcarmine',
        disabled && 'bg-disabled',
        className,
      )}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Primary;
